package songwritersnotebook.app

import kotlinx.coroutines.CoroutineDispatcher
import androidx.compose.runtime.Composable
import androidx.navigation.NavHostController
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding

interface Platform {
    val name: String
    val deviceName: String
}

expect fun getPlatform(): Platform

expect val ioDispatcher: CoroutineDispatcher

object AppDispatchers {
    val IO = ioDispatcher
}

expect fun ByteArray.toFirebaseData(): dev.gitlive.firebase.storage.Data

expect fun parseJsonToNative(jsonString: String): Any?

expect suspend fun callIfJs(name: String, callable: Any, data: Any?, authToken: String? = null): Any?
expect suspend fun jsResultPromiseAwait(promise: Any?): Any?

expect class JsHttpsCallableResult {
    constructor(rawData: Any?)
    fun data(): Any?
}

expect fun <T> Any?.jsUnsafeCast(): T

@Composable
expect fun SyncWebUrl(navController: NavHostController)

expect fun extractMapFromJsResult(result: Any?): Map<String, Boolean>

expect fun extractPronunciationsFromJsResult(result: Any?): Map<String, String>

expect fun extractUrlFromJsResult(result: Any?): String?

fun logNativeObject(obj: Any?) {
    logNativeObjectActual(obj)
}

expect fun logNativeObjectActual(obj: Any?)

@Composable
fun Modifier.adaptiveSheetWidth(): Modifier {
    val platform = getPlatform().name
    return if (platform.contains("Web", ignoreCase = true) || platform.contains("Desktop", ignoreCase = true)) {
        this.widthIn(max = 600.dp).fillMaxWidth()
    } else {
        this.fillMaxWidth()
    }
}

expect suspend fun getAppCheckToken(): String?

